var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail240X240(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.776 55.6612C56.0531 54.8623 46.5307 53.6534 46.5307 53.6534C46.5307 53.6534 38.6177 62.0249 31.6296 96.8303L20.4625 152.45C20.4625 152.45 24.172 152.33 26.1775 152.639C30.1075 153.244 33.9962 154.252 37.903 154.993C46.3797 156.601 55.0439 157.436 63.5772 158.709C82.7223 161.567 101.232 167.084 119.961 171.841C138.262 176.49 156.762 180.644 175.156 184.92C182.91 186.723 190.588 189.004 198.391 190.571C200.317 190.957 201.237 180.907 201.611 179.046C204.093 166.684 206.454 154.31 208.593 141.882C211.19 126.794 215.237 112.025 217.798 96.9619C218.187 94.6735 221.19 86.8189 217.268 86.7348C216.219 86.7123 215.248 86.5689 214.226 86.3638C209.466 85.4081 204.892 83.5309 200.1 82.5688C198.813 82.3104 197.684 81.6043 196.404 81.3472C193.761 80.8167 190.884 80.9355 188.2 80.5524C181.075 79.5356 174.169 76.9212 167.116 75.4669C152.855 72.5268 138.647 69.4506 124.31 66.8725C103.151 63.0677 81.9728 59.2468 60.776 55.6612Z",
    stroke: "#1A2147",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0403 54.8355C46.7545 55.1797 48.46 56.9974 50.0498 57.8249C56.8676 61.3735 63.7939 65.3449 69.7122 70.2647C85.1989 83.1384 116.873 124.385 116.873 124.385C116.873 124.385 177.503 100.918 211.123 91.776C213.147 91.2255 217.597 90.85 218.896 89.1836",
    stroke: "#1A2147",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M173.186 94.2053C180.926 100.693 179.061 115.024 173.389 121.345C167.718 127.667 156.846 127.533 149.107 121.045C141.368 114.558 143.233 100.227 148.904 93.9052C154.576 87.5835 165.447 87.7179 173.186 94.2053Z",
    fill: "#C7EBC5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail240X240);
export default __webpack_public_path__ + "static/media/email-240x240.1b36b1146ad684a3282dd56edb27d9c2.svg";
export { ForwardRef as ReactComponent };